function triggerEcommerceTracking(
  wrapperId,
  userType = "person",
  options = {}
) {
  const wrapper = document.getElementById(wrapperId);
  if (
    wrapper &&
    wrapper.querySelectorAll("[data-gtm-ecommerce-item-id]").length > 0
  ) {
    const event = new CustomEvent("gtm_ecommerce_item_list_rendering", {
      detail: {
        wrapperSelector: `#${wrapperId}`,
        userType,
        ...options,
      },
    });
    window.dispatchEvent(event);
  }
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default triggerEcommerceTracking;